import React, { useState } from 'react';
import { toast } from 'sonner';
import { Phone, Mail, MapPin, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { PublicNav } from '@/components/public/PublicNav';
import { Footer } from '@/components/public/Footer';
import api from '@/lib/api';

export default function Contact() {
  const [form, setForm] = useState({ nome: '', email: '', telefone: '', destino: '', periodo: '', mensagem: '' });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nome) { toast.error('Informe seu nome'); return; }
    setLoading(true);
    try {
      const r = await api.post('/public/leads', form);
      toast.success(r.data.message || 'Contato enviado!');
      setForm({ nome: '', email: '', telefone: '', destino: '', periodo: '', mensagem: '' });
    } catch (err) {
      toast.error('Não foi possível enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <PublicNav />
      <section className="section-wash border-b border-border/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight">Contato</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">Conte sobre a viagem que você deseja. Retornamos com as melhores opções.</p>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-3 gap-10">
          <form onSubmit={submit} className="lg:col-span-2 rounded-2xl bg-card p-6 sm:p-8 card-shadow" data-testid="public-contact-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <Label htmlFor="nome">Nome *</Label>
                <Input id="nome" value={form.nome} onChange={set('nome')} placeholder="Seu nome" className="mt-1.5" data-testid="contact-nome" />
              </div>
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={form.email} onChange={set('email')} placeholder="voce@email.com" className="mt-1.5" data-testid="contact-email" />
              </div>
              <div>
                <Label htmlFor="telefone">Telefone</Label>
                <Input id="telefone" value={form.telefone} onChange={set('telefone')} placeholder="(11) 99999-9999" className="mt-1.5" data-testid="contact-telefone" />
              </div>
              <div>
                <Label htmlFor="destino">Destino desejado</Label>
                <Input id="destino" value={form.destino} onChange={set('destino')} placeholder="Ex: Nordeste, Europa..." className="mt-1.5" data-testid="contact-destino" />
              </div>
              <div className="sm:col-span-2">
                <Label htmlFor="periodo">Período aproximado</Label>
                <Input id="periodo" value={form.periodo} onChange={set('periodo')} placeholder="Ex: Março/2026, 7 dias" className="mt-1.5" data-testid="contact-periodo" />
              </div>
              <div className="sm:col-span-2">
                <Label htmlFor="mensagem">Mensagem</Label>
                <Textarea id="mensagem" value={form.mensagem} onChange={set('mensagem')} placeholder="Conte mais sobre a viagem que você deseja..." rows={4} className="mt-1.5" data-testid="contact-mensagem" />
              </div>
            </div>
            <Button type="submit" size="lg" disabled={loading} className="mt-6" data-testid="public-contact-submit-button">
              {loading ? 'Enviando...' : <>Enviar contato <Send className="ml-2 h-4 w-4" /></>}
            </Button>
          </form>

          <div className="rounded-2xl bg-primary text-primary-foreground p-6 sm:p-8 h-fit">
            <h3 className="font-display text-xl font-semibold">Fale com a gente</h3>
            <p className="mt-2 text-sm text-primary-foreground/80">Atendimento de segunda a sábado.</p>
            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-center gap-3"><Phone className="h-5 w-5" /> (11) 98016-8518</li>
              <li className="flex items-center gap-3"><Mail className="h-5 w-5" /> sandra@sandratur.com.br</li>
              <li className="flex items-center gap-3"><MapPin className="h-5 w-5" /> São Paulo - SP</li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
